/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/prefer-as-const */
import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Button } from "@mui/material";
import { Container } from "./styles";
import TicketingService from "../../../../services/ticketing";
import Loader from "../../../../components/Loader";
import { useToast } from "../../../../hooks/toast";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  color: "#472b74",
  borderRadius: "12px",
};

interface AlertaInterface {
  open?: boolean;
  handleClose?: () => void;
  show?: boolean;
  pedidoAlterado?: any;
  event?: any;
  id?: any;
  external?: any;
  verificado?: boolean;
}

const ModalVerificar: React.FC<AlertaInterface> = ({
  show,
  handleClose,
  open,
  pedidoAlterado,
  event,
  id,
  verificado,
  external,
}) => {
  const services = { ticketingService: new TicketingService() };
  const { addToast } = useToast();
  const [loading, setLoading] = React.useState<boolean>(true);

  const handleStatus = React.useCallback(async () => {
    try {
      setLoading(true);
      // const response = await services.ticketingService.getRecargaId(id);
    } catch (err: any) {
      const { ...error } = err;

      console.log(error);

      addToast({
        type: "error",
        title: `${error.response.data.detail}`,
        description: `${error.response.data.detail}`,
      });
    } finally {
      setLoading(false);
      handleClose();
      pedidoAlterado(true);
      addToast({
        type: "success",
        title: `Sucesso`,
        description: `Status do Pedido alterado com Sucesso.`,
      });
    }
  }, []);

  return (
    <Container>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          borderRadius: "10px",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            className="title"
            sx={{
              fontWeight: "bold",
            }}
          >
            Pedido {external}
          </Typography>
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, mb: 2 }}
            className="text"
          >
            Deseja marcar o pedido atual como{" "}
            <strong style={{ color: "#dc582a" }}>
              {verificado ? "NÃO VERIFICADO" : "VERIFICADO"}
            </strong>{" "}
            ?
          </Typography>
          <Button
            onClick={handleStatus}
            sx={{
              backgroundColor: "var(--purple)",
              color: "white",
              ":hover": {
                color: "var(--orange)",
                fontWeight: "bold",
              },
            }}
          >
            {verificado ? "NÃO VERIFICADO" : "VERIFICADO"}
          </Button>
        </Box>
      </Modal>
    </Container>
  );
};

export default ModalVerificar;
